export default __webpack_public_path__ + "565df397224db270c99e5cf5bcd20b13.svg";